<template>
  <div class="bg-primaryLight2 w-full px-0 sm:px-3 py-3 md:py-4 md:px-5">
    <div class="flex justify-between items-center gap-2 px-3 sm:px-0 mb-3 capitalize md:mb-[1.18rem]">
      <!-- section title -->
      <h3 class="font-bold text-base text-[#000000] sm:text-[17px] 3xl:text-[18px]">
        {{ $t('general.exclusive_offers') }}
      </h3>
      <!-- more link -->
      <NuxtLink :to="ROUTESNAMES?.user?.exclusiveOffers" class="text-primaryLighter group cursor-pointer hover:brightness-125 whitespace-nowrap duration-150 transition-colors font-bold text-[0.8rem] xs:text-[0.9rem] md:text-[1rem] flex flex-nowrap gap-0.5 md:gap-1 items-center">
        <span>{{ $t('general.more_exclusive_offers_content')}}</span>
        <svg class="ltr:group-hover:translate-x-[3px] rtl:group-hover:translate-x-[-3px] transition-[transform] duration-150 ltr:rotate-180 w-[19px] h-[19px] xs:w-[20px] xs:h-[20px] md:w-[23px] md:h-[23px]" xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 256 256"><path fill="currentColor" d="M168.49 199.51a12 12 0 0 1-17 17l-80-80a12 12 0 0 1 0-17l80-80a12 12 0 0 1 17 17L97 128Z"/></svg>
      </NuxtLink>
    </div>
    <div>
      <ItemsSlider v-if="exclusiveOffersList.length <= 0" gap="1.5" wrapperTagType="ul">
        <div v-for="(item, index) in Array.from({ length: 4 })" :key="index">
          <div class="product__card__hover relative ease-linear p-1.5 rounded-[0.625rem] duration-[0.15s] transition-[box-shadow,border-color] product_item min-w-[100px] w-full border bg-gray-100 overflow-hidden animate-pulse">
            <div class="relative h-[10rem] sm:h-[11rem] md:h-[11.563rem] lg:h-[11.4rem] 2xl:h-[11.8rem] min-w-[11.563rem] cursor-pointer rounded-[0.438rem] overflow-hidden bg-gray-300">

            </div>
          </div>
        </div>
      </ItemsSlider>
      <ItemsSlider v-if="exclusiveOffersList && exclusiveOffersList.length > 0" gap="1.5" wrapperTagType="ul">
        <HomeOfferItem v-for="(product, index) in exclusiveOffersList" :key="product.id || index" :item="product" />
      </ItemsSlider>
    </div>
  </div>
</template>

<script>
import { ItemsSlider } from "@/components";
import HomeOfferItem from "@/components/user/productItemDesigns/HomeOfferItem.vue";

export default {
  components: {
    ItemsSlider,
    HomeOfferItem
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
    exclusiveOffersList: {
      type: Array,
      required: true,
      default: () => ([]),
    },
  }
}
</script>

<style></style>